import React, { FC } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './continueApply.module.scss';
const cx = classnames.bind(styles);

interface IContinueApplyContinueApplyModalProps {
  visible: boolean;
  onApply: () => void;
  onClose: () => void;
}

const ContinueApplyModal: FC<IContinueApplyContinueApplyModalProps> = ({ visible, onApply, onClose }) => {
  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>
          중단된 응시 단계부터
          <br />
          이어하시겠습니까?
        </strong>
        <div className={cx('btnArea')}>
          <button className={cx('btn', 'close')} type={'button'} onClick={onClose}>
            아니오
          </button>
          <button className={cx('btn', 'apply')} type={'button'} onClick={onApply}>
            네
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ContinueApplyModal;
